'use strict';

import {Component, EventEmitter} from '@angular/core';
import {CORE_DIRECTIVES} from '@angular/common';

@Component({
  selector: 'zippy',
  events: ['open', 'close'],
  inputs: ['title', 'visible', 'type', 'empty'],
  template: `
    <div class="zippy zippy-{{type}}" [ngClass]="{'zippy-empty': empty}">
      <div class="zippy-title" (click)="toggle()">
        <span class="zippy-indicator">{{ visible ? '&#9662;' : '&#9656;' }}</span>
        {{title}}
      </div>
      <div class="zippy-content" [ngClass]="{'zippy-hidden': !visible}">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .zippy-title{padding:10px;border-radius:2px;margin:2px 0;line-height:1.5em;background-color:#f2f2f2;cursor:pointer}.zippy-success>.zippy-title{color:#00aa13;background-color:rgba(0,170,19,0.08)}.zippy-error>.zippy-title{color:#e53935;background-color:rgba(229,57,53,0.06)}.zippy-redirect>.zippy-title{color:#263238;background-color:rgba(38,50,56,0.08)}.zippy-info>.zippy-title{color:#0033a0;background-color:rgba(0,51,160,0.08)}span.zippy-indicator{font-size:1.2em;margin-right:0.2em;position:relative;top:0}.zippy-content{padding:15px 0}.zippy-empty .zippy-title{cursor:default}.zippy-empty .zippy-indicator{display:none}.zippy-empty .zippy-content{display:none}.zippy-hidden{overflow:hidden;visibility:hidden;height:0;padding:0}
  `],
  directives: [CORE_DIRECTIVES]
})
export class Zippy {

  constructor() {
    this.type = 'general';
    this.visible = false;
    this.empty = false;
    this.open = new EventEmitter();
    this.close = new EventEmitter();
  }

  toggle() {
    this.visible = !this.visible;
    if (this.empty) return;
    (this.visible) ? this.open.next() : this.close.next();
  }
}
